export default __webpack_public_path__ + "static/media/chapterExam.753acc75.png";